import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuccess = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .8,
			y: 1.05,
			width: 18.4,
			height: 18.4,
			rx: 9.2,
			fill: "#D4F7E3"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .8,
			y: 1.05,
			width: 18.4,
			height: 18.4,
			rx: 9.2,
			stroke: "#118A5D",
			strokeWidth: 1.6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6666 7.04199L8.24992 13.4587L5.33325 10.542",
			stroke: "#118A5D",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgSuccess;
